export default () => {
  $('select.custom-select').each(function () {
    $(this)
      .on('select2:select', function () {
        $(this).trigger('focus'); // Maintain focus after select https://github.com/select2/select2/issues/4384
      })
      .selectWoo();
  });

  // Fake COUPON form to position it inside the checkout form
  $( document.body ).on( 'click', 'a.showfakecoupon', function(e){
    e.preventDefault();

    $( '.fake-woocommerce-form-coupon' ).slideToggle( 400, function() {
      $( '.fake-woocommerce-form-coupon' ).find( ':input:eq(0)' ).trigger('focus');
    });
  });

  $('.fake-woocommerce-form-coupon input[name="coupon_code"]').on( 'input change', function(){
    $('form.checkout_coupon input[name="coupon_code"]').val($(this).val());
  });

  // On button click, submit WooCommerce hidden default coupon form
  $('.fake-woocommerce-form-coupon .apply-coupon').on( 'click', function(e){
    e.preventDefault();
    $('form.checkout_coupon .button').trigger('click');
  });

  // On coupon sent remove input value and hide form
  $(document.body).on('applied_coupon_in_checkout', function(){
    $('a.showfakecoupon').trigger('click');
    $('.fake-woocommerce-form-coupon input[name="coupon_code"]').val('');
  });


  // Fake LOGIN form to position it inside the checkout form
  $( document.body ).on( 'click', 'a.showfakelogin,a.showlogin', function(e){
    e.preventDefault();
    $( '.fake-woocommerce-form-login' ).slideToggle( 400 );
  });

  $('.fake-woocommerce-form-login input[name="username"]').on( 'input change', function(){
      $('form.woocommerce-form-login input[name="username"]').val($(this).val());
  });
  $('.fake-woocommerce-form-login input[name="password"]').on( 'input change', function(){
      $('form.woocommerce-form-login input[name="password"]').val($(this).val());
  });
  $('.fake-woocommerce-form-login input[name="rememberme"]').on( 'click', function(){
    $('form.woocommerce-form-login input[name="rememberme"]').trigger('click');
  });

  // On button click, submit WooCommerce hidden default login form
  $('.fake-woocommerce-form-login .woocommerce-form-login__submit').on( 'click', function(e){
    e.preventDefault();
    $('form.woocommerce-form-login .woocommerce-form-login__submit').trigger('click');
  });

  // VAT Custom validation based on site/web/app/plugins/eu-vat-for-woocommerce/includes/js/alg-wc-eu-vat.js
  var $input_is_pro_paragraph = $( '#billing_is_pro_field' );
  var $input_is_pro           = $( 'input[name="billing_is_pro"]' );
  var $vat_paragraph          = $( 'p[id="billing_eu_vat_number_field"]' );
	var $country_select			    = $( '#billing_country' );
  var $vat_input              = $( 'input[name="billing_eu_vat_number"]' );
  var done_input_interval     = 1000; // time in ms
  var input_timer             = ''; // timer identifier
  var $progress_text = $( '<span class="description"></span>' ).appendTo( $vat_paragraph.find('.woocommerce-input-wrapper').eq(0) );

  maybe_show_input_is_pro();

  // On VAT number input start typing, start the validation countdown
	$vat_input.on( 'input', function() {
		clearTimeout( input_timer );
		input_timer = setTimeout( braindex_validate_vat, done_input_interval );
	} );

  // Validate VAT number if is_pro checkbox is changed
  $input_is_pro.on('change', function() {
      braindex_validate_vat();
	});

  // Maybe show the is_pro checkbox. Show only if country is from EU and is not ES
  $country_select.on('change', () => {
    // reset the vat field as we want the customer to enter it again to recalculate vat
    $vat_input.val('');

    maybe_show_input_is_pro();
  });

  function maybe_show_input_is_pro(){
    var country = $country_select.val();
    if( country != 'ES' && is_eu_country( country ) ){
      $input_is_pro_paragraph.show();
    }else{
      $input_is_pro_paragraph.hide();
    }
  }

  // Validate VAT Number with VIES
	function braindex_validate_vat() {

    $progress_text.text('');
    // $vat_paragraph.removeClass( 'woocommerce-invalid' );
    // $vat_paragraph.removeClass( 'woocommerce-validated' );
    // $vat_paragraph.addClass( 'validate-required' );

    var country = $country_select.val();
    if( ! is_eu_country( country ) || country == 'ES' ) return;

		var vat_number_to_check = $vat_input.val();
		if ( '' != vat_number_to_check ) {

      $('form.woocommerce-checkout').block({
        message: null,
        overlayCSS: {
          // background: getComputedStyle(document.documentElement).getPropertyValue('--bg-secondary'),
          background: 'transparent',
          opacity: 0.6,
        },
      });

			// Validating EU VAT Number through AJAX call
			// Action/params/nonce/response shape follow eu-vat-for-woocommerce >= 4.6 (WPFactory rebrand),
			// see site/web/app/plugins/eu-vat-for-woocommerce/includes/class-wpfactory-wc-eu-vat-ajax.php
			var data = {
				'action': 'wpfactory_wc_eu_vat_validate_action',
				'nonce': $('#wpfactory_wc_eu_vat_nonce_field').val(),
				'eu_vat_to_check': vat_number_to_check,
				'billing_country': $country_select.val(),
				'billing_company': $('#billing_company').val(),
			};

			$.ajax( {
				type: "POST",
        // eslint-disable-next-line
				url: braindex_vars.ajax_url, // Defined in site/web/app/plugins/braindex/public/class-braindex-public.php
				data: data,
				success: function( response ) {

          $('form.woocommerce-checkout').unblock();

          // No PRO
          if ( $input_is_pro.is(':checked') !== true ) {
            $( document.body ).trigger( 'update_checkout' );
            return;
          }

          if( typeof response.is_vat_valid === 'undefined' ) {
            console.log('Can\'t validate VAT number');
            return;
          }

					if ( response.is_vat_valid ) {
						$vat_paragraph.addClass( 'woocommerce-validated' );
            // eslint-disable-next-line
            $progress_text.text( braindex_vars.valid_vat_text ); // Defined in site/web/app/plugins/braindex/public/class-braindex-public.php
					} else {
						// eslint-disable-next-line
            $progress_text.text( braindex_vars.invalid_vat_text ); // Defined in site/web/app/plugins/braindex/public/class-braindex-public.php
					}

					$( document.body ).trigger( 'update_checkout' );
				},
			} );
		} else {
			// VAT input is empty
			if ( $vat_paragraph.hasClass( 'validate-required' ) ) {
				// Required
				$vat_paragraph.addClass( 'woocommerce-invalid' );
			}

			$( document.body ).trigger( 'update_checkout' );
		}
	}

  /**
   * Returns if the country is from the EU.
   * @param {string} country
   * @returns bool
   *
   */
  function is_eu_country( country ){
    switch ( country ) {
      case 'ES':
      case 'DE':
      case 'AT':
      case 'BE':
      case 'BG':
      case 'CY':
      case 'HR':
      case 'DK':
      case 'SK':
      case 'SI':
      case 'EE':
      case 'FI':
      case 'FR':
      case 'GR':
      case 'HU':
      case 'IE':
      case 'IT':
      case 'LV':
      case 'LT':
      case 'LU':
      case 'MT':
      case 'NL':
      case 'PL':
      case 'PT':
      case 'CZ':
      case 'RO':
      case 'SE':
        return true;

      default:
        return false;
    }
  }
}

